module.exports = __webpack_public_path__ + "img/cost_assist_icon_new.15a10489.svg";